export const DataTable = ({ cols, rows, empty = "Nothing here yet.", testId }) => {
  if (!rows) return <div className="h-48 animate-pulse rounded-2xl bg-white" />;
  return (
    <div data-testid={testId} className="overflow-hidden rounded-2xl border border-blue-100 bg-white">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[640px] text-left text-sm">
          <thead className="bg-[#F4F8FD]">
            <tr>
              {cols.map(([h]) => (
                <th key={h} className="whitespace-nowrap px-5 py-3 text-[11px] font-bold uppercase tracking-widest text-slate-500">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={cols.length} className="px-5 py-10 text-center text-slate-400">{empty}</td></tr>
            ) : (
              rows.map((r, i) => (
                <tr key={r.id || `${r.date}-${r.driver_id || i}`} className="border-t border-slate-100 transition-colors hover:bg-blue-50/40">
                  {cols.map(([h, fn]) => (
                    <td key={h} className="whitespace-nowrap px-5 py-3.5 text-slate-700">{fn(r)}</td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
